import script from "./ProfileModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ProfileModal.vue?vue&type=script&setup=true&lang=js"

import "./ProfileModal.vue?vue&type=style&index=0&id=766a6007&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-766a6007"]])

export default __exports__